import { render, staticRenderFns } from "./RespostasIpi.vue?vue&type=template&id=945a444c&scoped=true&"
import script from "./RespostasIpi.vue?vue&type=script&lang=js&"
export * from "./RespostasIpi.vue?vue&type=script&lang=js&"
import style0 from "./RespostasIpi.vue?vue&type=style&index=0&id=945a444c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945a444c",
  null
  
)

export default component.exports